import React,{useEffect, useState, useContext} from 'react';
import {MyContext} from '../../login/MyContext';

import Inicio from '../inicio/Inicio';

import MaterialTable from 'material-table';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import axios from 'axios';

import ArticulosModal from "./ArticulosModal";
import Routes from '../../routes/Routes';


function Articulos() {
  
  const baseUrlAd = Routes.global.url_articulos; 
  const [data, setData]=useState([]);
  const [modalInsertar, setModalInsertar]=useState(false);
  const [modalEditar, setModalEditar]=useState(false);
  const [modalCategoria, setModalCategoria]=useState(false);
  const [frameworkSeleccionado, setFrameworkSeleccionado]=useState({
    id_articulo:'',
    nombre:'',
    categoria:'',
    stock:'',
    descripcion:'',
    precio_venta:'',
    precio_costo:'',
  });
  
  const handleSelected = (selectedFramework) => {
    setFrameworkSeleccionado((prevState) => ({
      ...prevState,
      nombre_categoria: selectedFramework.nombre_categoria
    }));
    setModalCategoria(false);
  };
   
  const handleChange=e=>{
    const {name, value}=e.target;
    setFrameworkSeleccionado((prevState)=>({
      ...prevState,
      [name]: value
    }))
   console.log(frameworkSeleccionado);
  }

  const abrirCerrarModalInsertar=()=>{
    setModalInsertar(!modalInsertar);
  }

  const peticionGet =async() =>{
    await axios.get(baseUrlAd)
    .then(response=>{
     setData(response.data);
    }).catch(error=>{
      console.log(error);
    })

  }

  const peticionPost = async() =>{
    var f = new FormData();
    f.append("nombre", frameworkSeleccionado.nombre);
    f.append("categoria", frameworkSeleccionado.nombre_categoria);
    f.append("stock", frameworkSeleccionado.stock);
    f.append("descripcion", frameworkSeleccionado.descripcion);
    f.append("precio_venta", frameworkSeleccionado.precio_venta);
    f.append("precio_costo", frameworkSeleccionado.precio_costo);
    f.append("METHOD", "POST_articulo");
    await axios.post(baseUrlAd,f)
    .then(response=>{
     setData(data.concat(response.data));
     abrirCerrarModalInsertar();
    }).catch(error=>{
      console.log(error);
    })

  }

  const peticionPut = async() =>{
    var f = new FormData();
    f.append("descripcion", frameworkSeleccionado.descripcion);
    f.append("precio_venta", frameworkSeleccionado.precio_venta);
    f.append("METHOD", "PUT_articulo");
    await axios.post(baseUrlAd,f, {params: {id_articulo: frameworkSeleccionado.id_articulo}})
    .then(response=>{
     var dataNueva = data;
     dataNueva.map(framework=>{
       if(framework.id_articulo===frameworkSeleccionado.id_articulo){
         framework.descripcion= frameworkSeleccionado.descripcion;
         framework.precio_venta= frameworkSeleccionado.precio_venta;
       }
     });
     setData(dataNueva);
     abrirCerrarModalEditar();
    }).catch(error=>{
      console.log(error);
    })

  }

  const abrirCerrarModalEditar=()=>{
    setModalEditar(!modalEditar);
  }

  const abrirCerrarModalCategoria=()=>{
    setModalCategoria(!modalCategoria);
  }

  const seleccionarFramework=(framework, caso)=>{
    setFrameworkSeleccionado(framework);
   if(caso==="Editar"){
    abrirCerrarModalEditar()
   } 
  } 

  useEffect(()=>{
    const interval = setInterval(() => { 
       peticionGet();  
     }, 1000);
   return () => setInterval(interval);
   },[])

  

  
  const columnas =[
    {
      title:"ID",
      field: "id_articulo",
      
    },
    {
      title:'NOMBRE',
      field:'nombre'
    },

    {
      title:'CATEGORÍA',
      field:'categoria'
    },
    {
      title:'STOCK',
      field:'stock'
    },

  ];

  const {rootState,logoutUser} = useContext(MyContext);
  const {isAuth,theUser,showLogin} = rootState;

  if(isAuth && theUser.rol =="usuario")
  {

    return (

        <div className="content-wrapper">
    
    <div className="content-header">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6">
            <h3 className="m-0"><button className="btn btn-primary" onClick={()=>abrirCerrarModalInsertar()}><i class="fas fa-plus-circle"></i> CREAR ARTICULO</button></h3>
          </div>
          <div className="col-sm-6">
            
          </div>
        </div>
      </div>
    </div>

   
    <section className="content">
      <div className="container-fluid">
        
        <div className="row">
        
          <div className="col-md-12">

         
            <div>
              
            <MaterialTable   
     
columns={columnas}
data={data}
title="ARTICULOS"
backIconButtonText='Página anterior'
pagination
fixedHeader

actions={[
    
    {
        icon : 'edit',
        tooltip: 'Editar',
        onClick: (event, framework)=>seleccionarFramework(framework, "Editar")
    }
]}
options={{
  actionsColumnIndex: -1
}}
options={{
 actionsCellStyle: {
 },

 headerStyle: { backgroundColor: "#55C3F9",  headerStyle: { position: 'sticky'}, boxShadow:"0 0  0 2px rgb(255,255,255)", color: "white" }
}}
localization={{
    header:{
    actions: 'ACCIONES'
    
  },
  body:{ 
    emptyDataSourceMessage:'No hay registros que mostrar',
    
   },

 
   pagination: {
     firstAriaLabel: 'Primera página',
     firstTooltip: 'Primera página',
     labelDisplayedRows: '{from}-{to} de {count}',
     labelRowsPerPage: 'Filas por página:',
     labelRowsSelect: 'filas',
     lastAriaLabel: 'Ultima página',
     lastTooltip: 'Ultima página',
     nextAriaLabel: 'Pagina siguiente',
     nextTooltip: 'Pagina siguiente',
     previousAriaLabel: 'Pagina anterior',
     previousTooltip: 'Pagina anterior',
   },
   toolbar: {
     searchPlaceholder: 'Buscar',
     searchTooltip: 'Buscar',
     showColumnsAriaLabel: 'Mostrar columnas',
     showColumnsTitle: 'Mostrar columnas',
   },

   
}}

/>

<Modal isOpen={modalInsertar}>
 <ModalHeader><i class="fas fa-plus-circle"></i> CREAR ARTICULO</ModalHeader>
 <ModalBody>
   <div className="form-group">
   <div className="row">

   <div class="col-12">
     <label>Nombre:</label>
     <br/>
     <input type="text" className="form-control" name="nombre" onChange={handleChange}/>
     <br/>
     </div>

     </div>
     <div className="row">
     
     <div class="col-8 ">
     <label>Categoría:</label>
     <div class="input-group">
     <br/>
     <button className='btn btn-info'  onClick={()=>abrirCerrarModalCategoria()}><i class="fas fa-plus"></i></button>
     <input type="text" className="form-control" name="categoria" onChange={handleChange} value={frameworkSeleccionado.nombre_categoria} readOnly/>
     <br/>
     </div>
     </div>

     <div class="col-4">
     <label>Stock:</label>
     <br/>
     <input type="number" placeholder="0" className="form-control" name="stock" onChange={handleChange}/>
     <br/>
     </div>

     </div>

     <div className="row">

     <div class="col-12">
     <label>Descripción:</label>
     <br/>
     <input type="text" className="form-control" name="descripcion" onChange={handleChange}/>
     <br/>
     </div>

     </div>

     <div className="row">

     <div class="col-6">
     <label>P.Venta:</label>
     <br/>
     <input type="number" placeholder="0" className="form-control" name="precio_venta" onChange={handleChange}/>
     <br/>
     </div>

     <div class="col-6">
     <label>P.Costo:</label>
     <br/>
     <input type="number" placeholder="0" className="form-control" name="precio_costo" onChange={handleChange}/>
     <br/>
     </div>

     </div>

     
 
   </div>
 </ModalBody>
 <ModalFooter>
   <button className="btn btn-primary" onClick={()=>peticionPost()}>Insertar</button>{" "}
   <button className="btn btn-danger" onClick={()=>abrirCerrarModalInsertar()}>Cancelar</button>
 </ModalFooter>
</Modal>


<Modal isOpen={modalEditar}>
<ModalHeader cssModule={{'modal-title': 'w-100 text-center'}}><i class="fas fa-users-cog" style={{color:"#36BCFE"}}>
 </i> EDITAR ARTICULOS</ModalHeader>
 <ModalBody>
   <div className="form-group">
   <div className="row">
   
     <div class="col-12">
     <label>Nombre:</label>
     <br/>
     <input type="text" className="form-control" name="nombre" onChange={handleChange} 
     value={frameworkSeleccionado && frameworkSeleccionado.nombre} readOnly />
     <br/>
     </div>

     </div>
     
     <div className="row">

     <div class="col-8">
     <label>Categoría:</label>
     <br/>
     <input type="text" className="form-control" name="categoria" onChange={handleChange}
     value={frameworkSeleccionado && frameworkSeleccionado.categoria} readOnly />
     <br/>
     </div>

     <div class="col-4">
     <label>Stock:</label>
     <br/>
     <input type="number" placeholder="0" className="form-control" name="stock" onChange={handleChange}
     value={frameworkSeleccionado && frameworkSeleccionado.stock} readOnly />
     <br/>
     </div>

     </div>

     <div className="row">

     <div class="col-12">
     <label>Descripción:</label>
     <br/>
     <input type="text" className="form-control" name="descripcion" onChange={handleChange}
     value={frameworkSeleccionado && frameworkSeleccionado.descripcion}  />
     <br/>
     </div>

     </div>

     <div className="row">
      
     <div class="col-6">
     <label>P.Venta</label>
     <br/>
     <input type="number" placeholder="0" className="form-control" name="precio_venta" onChange={handleChange}
     value={frameworkSeleccionado && frameworkSeleccionado.precio_venta} />
     <br/>
     </div>

     <div class="col-6">
     <label>P.Costo</label>
     <br/>
     <input type="number" placeholder="0" className="form-control" name="precio_costo" onChange={handleChange}
     value={frameworkSeleccionado && frameworkSeleccionado.precio_costo} readOnly />
     <br/>
     </div>

     </div>

   </div>
 </ModalBody>
 <ModalFooter>
   <button className="btn btn-primary" onClick={()=>peticionPut()}><i class="fas fa-edit"></i> Editar</button>{" "}
   <button className="btn btn-danger" onClick={()=>abrirCerrarModalEditar()}>Cancelar</button>
 </ModalFooter>
</Modal>


<Modal isOpen={modalCategoria}>
<ModalBody>

   <ArticulosModal onSelect={handleSelected} /> 

 </ModalBody>
 <ModalFooter>
   <button className="btn btn-danger" onClick={()=>abrirCerrarModalCategoria()}>Cancelar</button>
 </ModalFooter>
</Modal>



            </div>
       
          </div>

         
        </div>   

      </div>
    </section>
   
  </div>
     )
    }
  
    else if(showLogin){
        return "";
    }
    else{
      return <Inicio/>;
    }
    
    }

export default Articulos